import * as React from "react";
import { PureComponent } from "react";
import MapWrapper from "../MapWrapper";
import MenuWrapper from "../MenuWrapper";
import "./style.scss";
import MenuToggler from "../MenuToggler";
import AppContext from "../../context/AppContext";
import InfoWindow from "../InfoWindow";

class TambylstwoMapa extends PureComponent {
  static contextType = AppContext;
  render() {
    const { infoWindow } = this.context;
    return (
      <div className="GlobalView">
        <MapWrapper />
        <MenuWrapper />
        <MenuToggler />
        {infoWindow.isVisible && <InfoWindow />}
      </div>
    );
  }
}

export default TambylstwoMapa;
